export const newsList = [
  {
    id: "news-1",
    title: "沉浸式科幻大片上线流媒体，视觉特效口碑两极分化",
    summary:
      "备受期待的科幻巨制本周上线主流流媒体平台，凭借极致的光影特效与宏大世界观迅速登上热播榜，但围绕剧情的讨论也出现明显分歧。",
    category: "影视",
    tags: ["科幻", "流媒体", "热播"],
    author: "天天影评",
    date: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20city%20at%20night%20with%20neon%20lights%20and%20flying%20vehicles%2C%20dramatic%20teal%20and%20orange%20color%20grade%2C%20film%20poster%20aesthetic%2C%20highly%20detailed%2C%20moody%20atmosphere&width=800&height=600&seq=news-scifi-01&orientation=landscape",
    content: [
      "本周，那部宣传了近一年的科幻大片终于登陆流媒体平台，上线仅一天便冲上平台热播榜首位。影片构建了一个空前庞大的未来世界观，从悬浮都市到深空舰队，每一帧都在挑战观众的想象力。",
      "技术层面几乎是无可挑剔的。导演团队采用了大量实景与虚拟拍摄结合的手法，光影层次丰富，太空场景的粒子细节处理得相当细腻。不少观众表示，光是视觉效果就值回票价。",
      "然而围绕剧情的讨论却出现了明显分歧。一部分观众认为影片节奏偏慢、人物动机铺垫不足，另一部分观众则认为这种留白正是科幻作品的魅力所在，需要二刷才能读懂细节。",
      "无论评价如何，这部作品确实重新点燃了大众对硬核科幻的关注。片方也透露，续集已进入前期筹备阶段，预计将在两年后与观众见面。",
    ],
  },
  {
    id: "news-2",
    title: "华语乐坛年度盛典落幕，新锐歌手摘得最佳新人奖",
    summary:
      "年度音乐盛典昨晚圆满落幕，现场汇集了众多实力唱将。一位出道仅两年的新锐歌手爆冷拿下最佳新人，成为当晚最大黑马。",
    category: "音乐",
    tags: ["音乐盛典", "新人", "颁奖"],
    author: "音乐前线",
    date: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20concert%20stage%20with%20spotlights%20and%20microphone%20silhouette%2C%20warm%20orange%20and%20gold%20stage%20lighting%2C%20crowd%20blurred%20in%20background%2C%20cinematic%20music%20award%20atmosphere&width=800&height=600&seq=news-music-award-02&orientation=landscape",
    content: [
      "昨晚的年度音乐盛典堪称一场视听盛宴，从开场交响乐团到压轴的群星合唱，两个多小时的演出几乎没有冷场。红毯环节更是汇聚了当下华语乐坛最受关注的面孔。",
      "本次盛典的最大惊喜来自最佳新人奖。一位出道仅两年的新锐歌手凭借融合民谣与电子元素的首张专辑，击败了多位热门候选人。她在获奖感言中数度哽咽，感谢一路支持她的歌迷。",
      "资深乐评人指出，近两年华语乐坛的创作风格愈发多元，独立音乐人与主流厂牌的界限正在变得模糊，这为新人提供了更多被看见的机会。",
      "盛典结束后，相关话题迅速霸占社交平台热搜，多段现场表演视频的播放量在几小时内突破千万，足见大众对优质音乐现场的热情。",
    ],
  },
  {
    id: "news-3",
    title: "爆款户外真人秀第三季定档，原班人马全员回归",
    summary:
      "官方正式宣布，人气户外真人秀第三季将于下月开播，六位常驻嘉宾全员回归，本季还将加入全新挑战环节与素人互动设定。",
    category: "综艺",
    tags: ["真人秀", "定档", "回归"],
    author: "综艺观察",
    date: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20adventure%20variety%20show%20scene%20with%20mountains%20and%20camping%20tents%2C%20sunny%20sky%2C%20warm%20friendly%20atmosphere%2C%20travel%20documentary%20style%2C%20vibrant%20colors&width=800&height=600&seq=news-reality-show-03&orientation=landscape",
    content: [
      "这档以户外挑战为核心的人气真人秀，终于官宣第三季定档消息。节目组确认，前两季的六位常驻嘉宾将全员回归，这也是粉丝呼声最高的一种安排。",
      "据介绍，本季节目将走出熟悉的山区场景，转战三座风格迥异的城市，并首次引入素人深度互动环节，让嘉宾与当地居民共同完成任务。",
      "总导演在采访中表示，第三季在保留原有轻松搞笑基调的同时，会加入更多关于普通人的温暖故事，希望节目不只是娱乐，也能传递一些真实的情感。",
      "定档消息发布后，节目相关话题在两小时内登上热搜榜首，预告片的播放量也迅速攀升，观众对原班人马的团聚充满期待。",
    ],
  },
  {
    id: "news-4",
    title: "顶流演员被曝加盟古装大制作，造型概念图同步曝光",
    summary:
      "有媒体爆料，一位人气顶流演员将出演明年开拍的古装大制作，片方随后放出一组造型概念图，精致程度引发网友广泛讨论。",
    category: "八卦",
    tags: ["古装", "选角", "爆料"],
    author: "娱记在线",
    date: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20courtyard%20at%20dusk%20with%20red%20lanterns%20and%20silk%20costumes%2C%20elegant%20oriental%20aesthetic%2C%20cinematic%20warm%20golden%20light%2C%20highly%20detailed%20textile&width=800&height=600&seq=news-costume-drama-04&orientation=landscape",
    content: [
      "据多家娱乐媒体报道，一位近两年人气居高不下的顶流演员已与某头部制作公司完成签约，将出演一部投资规模较大的古装正剧，预计明年春天正式开机。",
      "消息传出后不久，片方罕见地在社交平台放出了一组造型概念图。图中人物服饰采用了大量手工刺绣与渐染工艺，配合考究的发冠与配饰，整体质感相当精致。",
      "有资深剧迷分析，从概念图的场景与服饰风格判断，这很可能是一部以架空王朝为背景的权谋题材作品，剧情应该会围绕宫廷与江湖两条主线展开。",
      "目前片方仍未正式官宣主演名单，仅表示一切以最终通告为准。网友则已在评论区展开了热烈猜测，相关话题的讨论量持续攀升。",
    ],
  },
  {
    id: "news-5",
    title: "经典悬疑剧宣布翻拍，全新导演阵容引发热议",
    summary:
      "一部豆瓣评分长期位居前列的经典悬疑剧正式宣布翻拍，制作方启用全新导演与编剧团队，原作粉丝对此既期待又担忧。",
    category: "影视",
    tags: ["悬疑", "翻拍", "经典"],
    author: "剧集研究所",
    date: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=foggy%20rainy%20city%20street%20at%20night%20with%20a%20lone%20silhouette%20and%20warm%20street%20lamps%2C%20mysterious%20noir%20mood%2C%20deep%20shadows%2C%20cinematic%20composition&width=800&height=600&seq=news-suspense-drama-05&orientation=landscape",
    content: [
      "这部曾在播出时引发全民推理热潮的经典悬疑剧，近日被正式确认将进行翻拍。消息一出，迅速登上各大平台的热搜榜单。",
      "制作方透露，此次翻拍将启用全新的导演与编剧团队，在保留原作核心诡计与人物关系的基础上，对时代背景与叙事节奏进行现代化的重构。",
      "原作粉丝的反应相当两极化。有人期待新技术与新视角能带来更好的呈现，也有人担心翻拍会破坏记忆中的经典，尤其是几位主角的塑造。",
      "制作方回应称，他们非常理解观众的顾虑，会以最大的诚意对待这部作品，并邀请原作的部分主创担任顾问，希望在致敬与创新之间找到平衡。",
    ],
  },
  {
    id: "news-6",
    title: "年度最受期待开放世界游戏公布实机演示",
    summary:
      "在一场线上发布会上，年度最受期待的开放世界游戏首次公开完整的实机演示，展示了无缝地图、动态天气与深度角色养成系统。",
    category: "游戏",
    tags: ["开放世界", "实机演示", "新游"],
    author: "游戏瞭望塔",
    date: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20open%20world%20landscape%20with%20floating%20islands%20and%20glowing%20crystals%2C%20magical%20atmosphere%2C%20vibrant%20sunset%20colors%2C%20video%20game%20concept%20art%20highly%20detailed&width=800&height=600&seq=news-openworld-game-06&orientation=landscape",
    content: [
      "在昨晚的线上发布会上，那款被玩家票选为年度最受期待的开放世界游戏，终于放出了长达二十分钟的实机演示，让无数等待已久的玩家大呼过瘾。",
      "演示中，开发团队展示了极具野心的无缝地图设计：从雪山到沙漠，再到漂浮于云海之上的浮空岛，玩家可以在几乎无加载的情况下自由穿行。",
      "动态天气系统是本次演示的亮点之一。昼夜更替与气候变化会真实影响怪物的行为、植物的生长乃至任务的触发条件，让世界显得格外鲜活。",
      "角色养成方面，游戏提供了一套可高度定制的技能树，玩家可以根据自己的战斗风格自由搭配。官方表示，正式版本还将支持多人合作探索模式。",
    ],
  },
  {
    id: "news-7",
    title: "独立音乐人巡演门票开售即售罄，加场请求刷屏",
    summary:
      "一位人气独立音乐人宣布开启新一轮城市巡演，首批门票在开售数分钟内被抢购一空，粉丝纷纷在评论区留言请求加场。",
    category: "音乐",
    tags: ["巡演", "独立音乐", "现场"],
    author: "现场笔记",
    date: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=intimate%20live%20house%20concert%20with%20warm%20string%20lights%20and%20acoustic%20guitar%20on%20stage%2C%20cozy%20vintage%20atmosphere%2C%20soft%20amber%20lighting%2C%20blurred%20audience&width=800&height=600&seq=news-indie-tour-07&orientation=landscape",
    content: [
      "这位以细腻歌词与现场感染力著称的独立音乐人，近日宣布将开启覆盖十座城市的新一轮巡演。消息发布后，粉丝群瞬间沸腾。",
      "首批门票于昨晚八点正式开售，多个场次的门票在数分钟内即告售罄。不少没能抢到票的粉丝涌入官方评论区，留言请求增加场次或更换更大的场馆。",
      "团队随后发布公告表示，正在与各场馆积极沟通加场事宜，同时提醒歌迷警惕非官方渠道的加价票，避免造成不必要的损失。",
      "近年来，独立音乐现场演出市场持续升温，越来越多年轻观众愿意走进小型场馆，感受与大型演唱会截然不同的亲密氛围。",
    ],
  },
  {
    id: "news-8",
    title: "音乐竞演节目赛制全面升级，跨界歌手同台竞技",
    summary:
      "新一季音乐竞演节目公布全新赛制，除了常规的专业歌手之外，还将邀请演员、运动员等跨界嘉宾同台，挑战风格融合改编。",
    category: "综艺",
    tags: ["音乐竞演", "跨界", "赛制"],
    author: "综艺观察",
    date: "2026-10-07",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20music%20competition%20stage%20with%20colorful%20led%20screens%20and%20grand%20piano%2C%20dramatic%20stage%20lighting%2C%20energetic%20competition%20atmosphere%2C%20high%20detail&width=800&height=600&seq=news-music-competition-08&orientation=landscape",
    content: [
      "这档连续多季保持高话题度的音乐竞演节目，本季在赛制上做了一次大胆的革新：打破歌手专属的壁垒，邀请来自不同领域的跨界嘉宾登上舞台。",
      "节目组介绍，每位参赛者都将面临风格融合改编的挑战，需要在有限的准备时间内，把原曲改编成完全不同的曲风，并接受现场观众的即时投票。",
      "首期录制中，一位演员出身的嘉宾以摇滚方式重新演绎了一首抒情老歌，出乎意料地获得全场最高分，也让评审团对跨界选手刮目相看。",
      "业内人士认为，这种赛制升级既增加了节目的可看性，也让观众看到音乐表达更多元的可能性，有望为同类节目提供新的思路。",
    ],
  },
  {
    id: "news-9",
    title: "暑期档动画电影票房再创新高，国创作品表现亮眼",
    summary:
      "今年暑期档动画电影票房刷新近五年纪录，多部国产动画凭借精良制作与创新题材获得口碑与票房双丰收。",
    category: "影视",
    tags: ["动画电影", "票房", "国创"],
    author: "票房速递",
    date: "2026-10-06",
    cover:
      "https://readdy.ai/api/search-image?query=whimsical%20animated%20movie%20scene%20with%20colorful%20clouds%20and%20a%20small%20hero%20on%20a%20flying%20boat%2C%20bright%20cheerful%20palette%2C%20storybook%20illustration%20style%2C%20highly%20detailed&width=800&height=600&seq=news-animation-film-09&orientation=landscape",
    content: [
      "随着最后一部主打影片下映，今年暑期档动画电影的票房成绩正式尘埃落定。整体票房刷新了近五年的同档期纪录，成为电影市场的一大亮点。",
      "其中多部国产动画表现格外亮眼。这些作品在视觉美术上大胆融合了水墨、剪纸等传统元素，同时在故事上聚焦成长与亲情等普世主题，收获了大量好评。",
      "有影评人分析，国产动画近年来的进步不仅体现在技术上，更体现在叙事能力的成熟。创作者开始更注重人物内心的真实刻画，而不是单纯依赖视觉奇观。",
      "业内普遍认为，随着制作水准的持续提升和观众审美的不断成长，国产动画有望在未来的国际市场中占据更重要的位置。",
    ],
  },
  {
    id: "news-10",
    title: "综艺嘉宾互动引发社交媒体讨论热潮",
    summary:
      "最新一期热门综艺中，两位嘉宾的一段即兴互动登上热搜，网友围绕其中的细节展开了各种解读，节目话题度再次攀升。",
    category: "八卦",
    tags: ["综艺", "热搜", "话题"],
    author: "娱记在线",
    date: "2026-10-05",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20television%20studio%20set%20with%20colorful%20sofa%20and%20warm%20ambient%20lighting%2C%20talk%20show%20atmosphere%2C%20clean%20modern%20interior%2C%20soft%20pastel%20tones&width=800&height=600&seq=news-variety-topic-10&orientation=landscape",
    content: [
      "最新一期热门综艺播出后，两位常驻嘉宾的一段即兴互动迅速登上社交平台热搜榜，相关话题的阅读量在数小时内突破了数亿次。",
      "事情的起因是节目中的一个游戏环节，两位嘉宾因为配合失误而产生了颇具喜剧效果的临场反应，弹幕瞬间被观众的笑声刷屏。",
      "节目播出后，网友围绕这段互动的各种细节展开了花样解读，有人制作了表情包，也有人剪辑了精彩片段分享，进一步推高了话题热度。",
      "节目组随后在官方账号回应称，感谢观众的喜爱，所有互动都是嘉宾们的真实反应，并预告下一期还将有更多精彩内容。",
    ],
  },
];